module.exports = __webpack_public_path__ + "static/media/chrpe_doc1.c23f0fce.jpg";